import React, { useState, useEffect, useRef, useCallback } from "react";
import { glossary, TEMPLATE_APP, QSC_APP_SPECIFIC_FIELDS, AI_APP_SPECIFIC_FIELDS, TEMPLATE_APP_ACCOUNTING, TEMPLATE_APP_CHART_OF_ACCOUNTS, TEMPLATE_APP_OUTPUT, TEMPLATE_APP_PERMISSION, TEMPLATE_APP_SOURCE_DATA_TABLES, TEMPLATE_APP_TEAM, TEMPLATE_APP_USE_CASE, RAC_APP_SPECIFIC_FIELDS } from "../Templates/Constants";
import SideNav from "./SideNav";
import {
    AppLayout,
    Button,
    ColumnLayout,
    Input,
    Icon,
    Textarea,
    Container,
    Header,
    Box,
    Grid,
    SpaceBetween,
    Link,
    ExpandableSection,
    ContentLayout,
    Table,
    Modal,
    Spinner,
    Select,
    Popover,
    StatusIndicator,
    HelpPanel,
    Flashbar,
    ButtonDropdown,
    Tabs,
    FileUpload,
    Alert,
    ProgressBar,
    Badge
} from "@amzn/awsui-components-react";

import "../../index.scss";
import "./styles.scss"
import { useSelector, useDispatch } from "react-redux";
import { API, graphqlOperation, Storage } from "aws-amplify";

import { useHistory, useLocation, useParams } from "react-router-dom";

import CustomMultiInputAdminForSelect from "../Templates/components/CustomMultiInputAdminForSelect";
import { getEditableFields, getLabelToFieldTypeMappers, sortQuarters } from "../Templates/Utils/FormMetadata";
import { setMetadataValues, getAllAppsForConsolidatedSheet, constructExcelSheetWithHeadersAndData } from "../Templates/Utils/AppActivityUtils";
import { getEmployeesByLoginList } from "../../utilities/papiAPIs";
import { configureGenericAppSync } from "src/context/AuthContextUtility";
import { addGRCControls } from "src/utilities/AppSyncPlusAPIs";
import {checkIfPortalAdmin, checkIfSupportAdmin, checkIfRaiseAdmin} from "src/checkPageAccess"
import RaiseAdmin from "src/Ateam-BI/RAISE/Admin/RaiseAdmin"
import RaiseHome from "src/Ateam-BI/RAISE/RaiseHome"
import { getAccessLevel } from "src/checkPageAccess"
import { ADD_APP_ACCESS_LEVELS } from 'src/constants/AppConstants'
import { TEMPLATES } from 'src/Ateam-BI/Templates/Constants';
import { FRISCO_DROPDOWN_METADATA_KEYS, PROCESS_KEYS } from 'src/Ateam-BI/Frisco/Constants';
import AccessDenied from "../../AccessDenied";
import ErrorComponent from "../Templates/components/ErrorComponent";
import { FLEXICO_TEMPLATE_KEYS } from "../FlexiCo/Constants";
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { AgGridReact } from "ag-grid-react";
import { all } from "axios";
import { configureGenericS3 } from "src/context/AuthContextUtility";
import { getAutomatedAppsByStatus } from "src/utilities/AutomatedAppsAPIs";
import { addAIApp } from "src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus";
import * as d3 from "d3";
import { listLogsByIdWithTimeFilterContainingPK } from "../AuditLogging/AuditLogsAPIs";
import BannerManager from "../Banners/BannerManager";
import PulseSurveyNotificationManager from "../PulseSurvey/PulseSurveyNotificationManager";
import { ALLOWED_COST_CENTERS } from "src/constants/costCenters";
import UploadAppModal from "../Templates/components/UploadAppModal";
import { uploadDocumentToVault } from 'src/Ateam-BI/Vault/VaultAPIs';
import { VAULT_SERVICES } from "src/Ateam-BI/Vault/constants";
import { GET_APPS_CACHE_KEY } from "src/AppConstants/CacheConstants";

// Component ServiceHomepage is a skeleton of a service's homepage using AWS-UI React components.
export default (props) => {
    const dispatch = useDispatch();
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const history = useHistory();
    const [NavOpen, setNavOpen] = useState(true);
    const [showLoadingIcon, setShowLoadingIcon] = useState(true);
    const [showTriggerInfoMsg, setShowTriggerInfoMsg] = useState(false);
    const [showSuccesModal, setShowSuccesModal] = useState(false);
    const userId = useSelector((globalState) => globalState.auth.userId);

    const [toolsOpen, setToolsOpen] = useState(false);
    const [fieldMetadata, setFieldMetadata] = useState({});
    const [loaders, setLoaders] = useState({})
    const [errorMessages, setErrorMessages] = useState({})
    const [reloadNotifiers, setReloadNotifiers] = useState({})
    const [allApps, setAllApps] = useState()
    const [columnsList, setColumnsList] = useState(null)
    const [selectedQuarter, setSelectedQuarter] = useState()
    const [selectedYear, setSelectedYear] = useState()
    const [selectedAuditLogQuarter, setSelectedAuditLogQuarter] = useState()
    const [selectedAuditLogYear, setSelectedAuditLogYear] = useState()
    const [showAuditLoader, setShowAuditLoader] = useState(null)
    const [uploadModalOpen, setUploadModalOpen] = useState(false)

    const search = useLocation().search
    const searchParams = new URLSearchParams(search)
    
    const [fieldTypes, setFieldTypes] = useState([
        {key : TEMPLATE_APP.ORGANIZATION, label: 'Organization'},
        {key : TEMPLATE_APP.CADENCE, label: 'Run frequency'},
        {key : TEMPLATE_APP.USE_CASE, label: 'Use case type'},
        {key : TEMPLATE_APP.DEVELOPER_TEAM, label: 'Developer teams'},
        {key : TEMPLATE_APP.ACCOUNTING_TEAM, label: 'Accounting teams'},
        {key : TEMPLATE_APP.INPUT_SOURCE_TYPE, label: 'Input source types'},
        {key : TEMPLATE_APP.AUTOMATION_TOOLS, label: 'Automation tools'},
        {key : TEMPLATE_APP.LEDGER_INFO, label: 'Ledger impacts'},
        {key : TEMPLATE_APP.REGION, label: 'Use case regions'},
        {key : TEMPLATE_APP.LAUNCH_QQ_YY, label: 'Launch dates'},
        {key : TEMPLATE_APP.OUTPUT, label: 'Process output type'},
        {key : TEMPLATE_APP.FINANCIAL_RELEVANCE, label: 'Financial relevance'},
        {key : TEMPLATE_APP.FINANCIAL_YEAR_IMPACT, label: 'Financial year impact'},
        {key : QSC_APP_SPECIFIC_FIELDS.MIGRATION_STATUS, label: 'QSC Migration Status'},
        {key : QSC_APP_SPECIFIC_FIELDS.QSC_DATASOURCE, label: 'QSC Data Source'},
        {key: QSC_APP_SPECIFIC_FIELDS.DOWNSTREAM_USE, label: 'QSC Downstream Use'},
        {key: RAC_APP_SPECIFIC_FIELDS.RAC_DATASOURCE, label: 'RAC Data Source'},
        {key: PROCESS_KEYS.team, label: 'Frisco teams'},
        {key: PROCESS_KEYS.business, label: 'Frisco businesses'},
        {key: PROCESS_KEYS.action, label: 'Frisco actions'},
        {key: PROCESS_KEYS.environment, label: 'Frisco Environments'},
        {key: PROCESS_KEYS.file_types, label: 'Frisco File types'},
        {key: `flexico_${FLEXICO_TEMPLATE_KEYS.file_types}`, label: 'FlexiCo File types'},
        {key: `flexico_${FLEXICO_TEMPLATE_KEYS.trigger_type}`, label: 'FlexiCo trigger type'}
    ]);
    const [hasAdminAccess, setHasAdminAccess] = useState(false)
    const [hasAiAdminAccess, setHasAiAdminAccess] = useState(false)
    const [aiAdminCheckDone, setAiAdminCheckDone] = useState(false)
    const gridRef = useRef();
      const [selectedRowIndex, setSelectedRowIndex] = useState(0)
  const [undoEditCount, setUndoEditCount] = useState(0) 
const [rowGroupColumns, setRowGroupColumns] = useState([])
const [allAppsEditLoader, setAllAppsEditLoader] = useState(null)
  const [allAppsEditError, setAllAppsEditError] = useState(null)
    const [annotationSaveSuccessMessage, setAnnotationSaveSuccessMessage] = useState(null)  
    const [multiSelectedRow, setMultiSelectedRow] = useState([])
    const [allAppsExportFileName, setAllAppsExportFileName] = useState('accounting_central_all_apps.csv') 
    const [showSaveAllAppsModal, setShowSaveAllAppsModal] = useState(false)
    const [showSaveAllAppsComments, setShowSaveAllAppsComments] = useState(false)
    const [activeTabId, setActiveTabId] = useState("all-apps")
    const [showRaisePreview, setShowRaisePreview] = useState(false)
    const [inactiveUsersData, setInactiveUsersData] = useState([])
    const [inactiveUsersLoader, setInactiveUsersLoader] = useState(false)
    const [inactiveUsersError, setInactiveUsersError] = useState(null)
    const [inactiveUsersColumnsList, setInactiveUsersColumnsList] = useState(null)
    const [outsideCostCenterData, setOutsideCostCenterData] = useState([])
    const [outsideCostCenterLoader, setOutsideCostCenterLoader] = useState(false)
    const [outsideCostCenterError, setOutsideCostCenterError] = useState(null)
    const [outsideCostCenterColumnsList, setOutsideCostCenterColumnsList] = useState(null)
    const [archivedApps, setArchivedApps] = useState([])
    const [archivedAppsLoading, setArchivedAppsLoading] = useState(false)
    const [bulkUploadData, setBulkUploadData] = useState(null)
    const [bulkUploadErrors, setBulkUploadErrors] = useState([])
    const [bulkUploadLoading, setBulkUploadLoading] = useState(false)
    const [bulkUploadProgress, setBulkUploadProgress] = useState(0)
    const [bulkUploadResult, setBulkUploadResult] = useState(null)
    const [bulkUploadModalVisible, setBulkUploadModalVisible] = useState(false)
    const [metricsLoading, setMetricsLoading] = useState(false)
    const [metricsAccessDenied, setMetricsAccessDenied] = useState(false)
    const [metricsAccessChecked, setMetricsAccessChecked] = useState(false)
    const [metricsError, setMetricsError] = useState(null)
    // RAISE admin access (RAISE_ADMINS group, or portal/support admin fallback).
    const [raiseAccessLoading, setRaiseAccessLoading] = useState(false)
    const [raiseAccessDenied, setRaiseAccessDenied] = useState(false)
    const [raiseAccessChecked, setRaiseAccessChecked] = useState(false)
    const [years, setYears] = useState([
        { label: "2020", value: 2020 },
        { label: "2021", value: 2021 },
        { label: "2022", value: 2022 },
        { label: "2023", value: 2023 },
        { label: "2024", value: 2024 },
        { label: "2025", value: 2025 },
        { label: "2026", value: 2026 },

    ])
    const quarters = [
        { label: "Q1", value: "Q1" },
        { label: "Q2", value: "Q2" },
        { label: "Q3", value: "Q3" },
        { label: "Q4", value: "Q4" }
                                    ]
    const defaultProjectColDef = {
        resizable: true,
        sortable: true,
        autoHeaderHeight: true,
        filter: true,
        floatingFilter: false,
        filterParams: {
          applyMiniFilterWhileTyping: true
        },
        headerClass: 'header-center',
        editable: true,
        // singleClickEdit: true,
        enableCellChangeFlash: true,
        enableRowGroup: false,
        enableCellChangeFlash: true,
        suppressHeaderMenuButton: true,
        suppressMovable: true,
        checkboxSelection: false, 
    headerCheckboxSelection: false,
    headerCheckboxSelectionFilteredOnly: true,
        cellClassRules: {
          'edited-row': (params) => { return params?.data?.isEdited || params?.data?.isNew},
          'new-row': (params) => { return params?.data?.isNew },
          }
        };
    const editableAppInfo = ['app_name','app_description','process_owner','grc_control_owner','status','region','cadence','ledger_info','automation_tools','organization','financial_relevance','vp','use_case','launch_qq_yy','financial_year_impact','pdd','annual_mer_savings','launch_mcm']
    const multipleValuedColumns = ['process_owner','region','cadence','ledger_info','automation_tools','organization','financial_relevance','vp','use_case']
    const textAreaTypes = ['app_description']
    const hideColumns = ['chart_of_accounts','source_data_tables','permission','developer_team','output','accounting_team']
    const lockedColumns = ['app_id', 'app_name', 'app_description', 'template_id']
    
    const mandatoryFields = ['app_name', 'app_description', 'status', 'organization', 'automation_tools', 'process_owner', 'vp', 'grc_control_owner', 'cadence', 'financial_relevance', 'ledger_info', 'financial_year_impact', 'pdd', 'annual_mer_savings', 'launch_mcm']
    const conditionallyMandatoryFields = {
        'launch_qq_yy': (row) => row[TEMPLATE_APP.STATUS] === 'Active'
    }
    
    // Global field types for user reporting
    const userFieldTypes = [
        { field: TEMPLATE_APP.GRC_CONTROL_OWNER, label: 'GRC Control Owner' },
        { field: TEMPLATE_APP.PROCESS_OWNER, label: 'Process Owner' },
        { field: TEMPLATE_APP.VP, label: 'VP' }
    ];
    
    // Global allowed cost centers for FGBS
    const allowedCostCenters = ALLOWED_COST_CENTERS;
    
    useEffect(() => {

        loadAllAppsView()
        if (searchParams.get("tab") === "ai-repo-control-panel") {
            checkAiAdminAccess();
        }

        return () => {
            // this now gets called when the component unmounts
        };
    }, []);

    // Re-check AI admin access when navigating to AI Repo Control Panel via sidebar
    const location = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("tab") === "ai-repo-control-panel") {
            if (!hasAiAdminAccess) {
                checkAiAdminAccess();
            }
            // Portal admins can also access — load archived apps if admin and not yet loaded
            if (hasAdminAccess && archivedApps.length === 0 && !archivedAppsLoading) {
                loadArchivedApps();
            }
        }
        if (params.get("tab") === "metrics" && !metricsLoading && !metricsAccessChecked) {
            loadMetricsDashboard();
        }
        if (params.get("tab") === "raise-admin-panel" && !raiseAccessLoading && !raiseAccessChecked) {
            loadRaiseAccess();
        }
    }, [location.search, hasAdminAccess, userId, currentStage]);

    useEffect(() => {
        // Load inactive users report after all apps are loaded
        if (allApps && allApps.length > 0) {
            loadInactiveUsersReport();
            loadOutsideCostCenterReport();
        }
    }, [allApps]);


    const getDate = (value) => {
        var d = new Date(parseFloat(value) * 1000)
        return d.toLocaleString()
      }

    const downloadAllapps = async () => {
        if (allApps?.length > 0) {
        const headers = [TEMPLATE_APP.APP_ID, 
            TEMPLATE_APP.APP_NAME, 
            TEMPLATE_APP.APP_DESCRIPTION,
            TEMPLATE_APP.TEMPLATE_ID, 
            TEMPLATE_APP.URL, 
            TEMPLATE_APP.PROCESS_OWNER,
            TEMPLATE_APP.GRC_CONTROL_OWNER,
            TEMPLATE_APP.FLASH_INFO_DESCRIPTION,
            TEMPLATE_APP.DEV_ALERT_MESSAGES,
            TEMPLATE_APP.TDD,
            TEMPLATE_APP.STATUS,
            TEMPLATE_APP.REGION,
            TEMPLATE_APP.CADENCE,
            TEMPLATE_APP.PROCESS_MJE_COUNT,
            TEMPLATE_APP.ANNUAL_MER_SAVINGS,
            TEMPLATE_APP.PDD,
            TEMPLATE_APP.LEDGER_INFO,
            TEMPLATE_APP.LAUNCH_MCM,
            TEMPLATE_APP.LAUNCH_QQ_YY,
            TEMPLATE_APP.INPUT_SOURCE_TYPE,
            TEMPLATE_APP.AUTOMATION_TOOLS,
            TEMPLATE_APP.ARD,
            TEMPLATE_APP.DATASOURCE,
            TEMPLATE_APP.ORGANIZATION,
            TEMPLATE_APP.FINANCIAL_RELEVANCE,
            TEMPLATE_APP.FINANCIAL_YEAR_IMPACT,
            TEMPLATE_APP.GRC_CONTROL_ID,
            TEMPLATE_APP.VP,
            TEMPLATE_APP.CREATE_TIME_STAMP,
            TEMPLATE_APP.CREATED_BY,
            TEMPLATE_APP.LAST_UPDATED_TIME_STAMP,
            TEMPLATE_APP.LAST_UPDATED_BY,
            TEMPLATE_APP.SIM_TICKET_URL,
            TEMPLATE_APP.SIM_TICKET_LABEL,
            TEMPLATE_APP.CHART_OF_ACCOUNT,
            TEMPLATE_APP.SOURCE_DATA_TABLES,
            TEMPLATE_APP.USE_CASE,
            TEMPLATE_APP.PERMISSION,
            TEMPLATE_APP.OUTPUT,
            TEMPLATE_APP.ACCOUNTING_TEAM,
            TEMPLATE_APP.DEVELOPER_TEAM
        ]

        constructExcelSheetWithHeadersAndData(headers, allApps)           
      }
    
    }

    const downloadEligibleGRCAppsToBePushed = async () => {
        if (allApps?.length > 0) {
        const headers = [TEMPLATE_APP.APP_ID, 
            TEMPLATE_APP.APP_NAME, 
            TEMPLATE_APP.APP_DESCRIPTION,
            TEMPLATE_APP.TEMPLATE_ID, 
            TEMPLATE_APP.URL, 
            TEMPLATE_APP.PROCESS_OWNER,
            TEMPLATE_APP.GRC_CONTROL_OWNER,
            TEMPLATE_APP.FLASH_INFO_DESCRIPTION,
            TEMPLATE_APP.DEV_ALERT_MESSAGES,
            TEMPLATE_APP.TDD,
            TEMPLATE_APP.STATUS,
            TEMPLATE_APP.REGION,
            TEMPLATE_APP.CADENCE,
            TEMPLATE_APP.PROCESS_MJE_COUNT,
            TEMPLATE_APP.ANNUAL_MER_SAVINGS,
            TEMPLATE_APP.PDD,
            TEMPLATE_APP.LEDGER_INFO,
            TEMPLATE_APP.LAUNCH_MCM,
            TEMPLATE_APP.LAUNCH_QQ_YY,
            TEMPLATE_APP.INPUT_SOURCE_TYPE,
            TEMPLATE_APP.AUTOMATION_TOOLS,
            TEMPLATE_APP.ARD,
            TEMPLATE_APP.DATASOURCE,
            TEMPLATE_APP.ORGANIZATION,
            TEMPLATE_APP.FINANCIAL_RELEVANCE,
            TEMPLATE_APP.FINANCIAL_YEAR_IMPACT,
            TEMPLATE_APP.GRC_CONTROL_ID,
            TEMPLATE_APP.VP,
            TEMPLATE_APP.CREATE_TIME_STAMP,
            TEMPLATE_APP.CREATED_BY,
            TEMPLATE_APP.LAST_UPDATED_TIME_STAMP,
            TEMPLATE_APP.LAST_UPDATED_BY,
            TEMPLATE_APP.SIM_TICKET_URL,
            TEMPLATE_APP.SIM_TICKET_LABEL,
            TEMPLATE_APP.CHART_OF_ACCOUNT,
            TEMPLATE_APP.SOURCE_DATA_TABLES,
            TEMPLATE_APP.USE_CASE,
            TEMPLATE_APP.PERMISSION,
            TEMPLATE_APP.OUTPUT,
            TEMPLATE_APP.ACCOUNTING_TEAM,
            TEMPLATE_APP.DEVELOPER_TEAM
        ]
        const eligibleApps = []
        let cutoffData;
        if (selectedQuarter?.value === "Q1") {
            cutoffData = new Date(selectedYear?.value, 0, 1)
        }
        else if (selectedQuarter?.value === "Q2") {
            cutoffData = new Date(selectedYear?.value, 3, 1)
        }
        else if (selectedQuarter?.value === "Q3") {
            cutoffData = new Date(selectedYear?.value, 6, 1)
        }
        else if (selectedQuarter?.value === "Q4") {
            cutoffData = new Date(selectedYear?.value, 9, 1)
        }

        allApps.forEach((app, index) => {

            if(app[TEMPLATE_APP.STATUS] === "Active" && !app[TEMPLATE_APP.GRC_CONTROL_ID]) {

                if(app[TEMPLATE_APP.LAUNCH_QQ_YY] && app[TEMPLATE_APP.LAUNCH_QQ_YY] !== "") {
                    let [launchQuarter, launchYear] = app[TEMPLATE_APP.LAUNCH_QQ_YY].split(" ")
                    launchYear = Number(launchYear)
                    if (launchYear < selectedYear?.value) {
                        eligibleApps.push(app)
                    } else if(launchYear === selectedYear?.value && launchQuarter < selectedQuarter?.value) {
                        eligibleApps.push(app)
                    }

                } else if(app[TEMPLATE_APP.CREATE_TIME_STAMP] && app[TEMPLATE_APP.CREATE_TIME_STAMP] !== "" && app[TEMPLATE_APP.CREATE_TIME_STAMP] !== "Invalid Date") {
                    const createdDate = new Date(app[TEMPLATE_APP.CREATE_TIME_STAMP])
                    if(createdDate < cutoffData) {
                        eligibleApps.push(app)
                    }
                }
            }

        })
       
        constructExcelSheetWithHeadersAndData(headers, eligibleApps, "GRCEligibleApps")           
      }
    
    }

    const pushAppsToGRC = async () => {
        setShowTriggerInfoMsg(true)
        await addGRCControls(selectedQuarter?.value,selectedYear?.value, function onSuccess(result) {
            
            loadAllAppsView()
            setShowSuccesModal(true)
            setShowTriggerInfoMsg(false)
            configureGenericAppSync()
        }, function onFailure(response) {
            configureGenericAppSync()
            setShowTriggerInfoMsg(false)
        })
    
    }


    function extractArrayFromFieldMetadataLabelCombo(fieldMetadata, key){
        let val = fieldMetadata[key].values
        let res = []
        for(let i in val){
            res.push(val[i]?.value)
        }
        return res
    }

    const loadAllAppsView = async () => {
        setAllAppsEditError("")
        setUndoEditCount(0)
        setAllAppsEditLoader("Checking access..")
        let isAdmin = await checkIfPortalAdmin(userId, currentStage)
        setHasAdminAccess(isAdmin)
        if(isAdmin){
            setAllAppsEditLoader("Loading all apps data..")
            let res = await getEditableFields()
            if(res.hasOwnProperty(TEMPLATE_APP.LAUNCH_QQ_YY)){
                sortQuarters(res[TEMPLATE_APP.LAUNCH_QQ_YY].values)
            }
            setFieldMetadata({...res})
            let apps = await getAllAppsForConsolidatedSheet()
            apps?.forEach((app) => {
                app[TEMPLATE_APP.CREATE_TIME_STAMP] = getDate(app[TEMPLATE_APP.CREATE_TIME_STAMP])
                app[TEMPLATE_APP.LAST_UPDATED_TIME_STAMP] = getDate(app[TEMPLATE_APP.LAST_UPDATED_TIME_STAMP])
            })
            setAllApps(apps)

            let keys = Object.keys(apps[0])
            let defs = []
            for (let i in keys) {
                if(hideColumns.includes(keys[i])){
                    continue
                }
                
                const isMandatory = mandatoryFields.includes(keys[i])
                const isConditionallyMandatory = conditionallyMandatoryFields.hasOwnProperty(keys[i])
                
                let def = {
                    field: keys[i], 
                    headerName: keys[i], 
                    resizable: true, 
                    sortable: true, 
                    enableRowGroup: true, 
                    editable: false,
                    filterParams: {
                      closeOnApply: false,
                      buttons: ['apply', 'clear'],
                      defaultOption: 'contains'
                    },
                    headerClass: isMandatory || isConditionallyMandatory ? 'mandatory-field-header' : '',
                    cellClass: (params) => {
                      return [
                        params?.data?.isEdited?.hasOwnProperty(keys[i]) ? 'edited-cell' : '',
                        editableAppInfo.includes(keys[i].toLowerCase()) ? 'editable-cell': ''
                      ].filter(Boolean);  // removes empty strings
                    }
                  }
                
                if (editableAppInfo.includes(keys[i])) {
                    def['editable'] = true
                    // using res instead of fieldMetadata since the setter takes time to update
                    if (res.hasOwnProperty(keys[i]) && res[keys[i]]?.values) {
                        def['cellEditor'] = 'agRichSelectCellEditor'
                        def['cellEditorParams'] = {
                            values: extractArrayFromFieldMetadataLabelCombo(res, keys[i]),
                            multiSelect: multipleValuedColumns.includes(keys[i]),
                        }
                        
                    }else if(textAreaTypes.includes(keys[i])){
                        def['cellEditor'] = 'agLargeTextCellEditor'
                        def['cellEditorPopup'] = true
                        def['cellEditorParams'] = {
                            maxLength: 1000
                        }
                    }else{
                        def['cellEditor'] = 'agTextCellEditor'
                        def['cellEditorParams'] = {
                            maxLength: 100
                        }
                        def['valueParser'] = (params) => {
                            return params.newValue || ''; // Ensure non-null value
                        };
                        def['valueFormatter'] = (params) => {
                            return params.value || '';
                        };
                    }
                }

                if(lockedColumns.includes(keys[i])){
                    def['lockVisible'] = true
                    def['suppressMovable'] = true
                    def['suppressDragLeaveHidesColumns'] = true
                }
                  defs.push(def)
            }
            setColumnsList(defs)
            setAllAppsEditLoader(null)
        }

        const currentYear = new Date().getFullYear();
        const years = generateYearOptions(currentYear - 10, currentYear );
        setYears(years)
        setShowLoadingIcon(false)
    }

    const generateYearOptions = (startYear, endYear) => {
        const minYear = 2020;
        const actualStart = Math.max(startYear, minYear); // Never go below 2020

        return Array.from(
            { length: endYear - actualStart + 1 },
            (_, i) => {
                const year = actualStart + i;
                return { label: String(year), value: year };
            }
        );
    };

    const saveChangedApps = async () => {
        setAllAppsEditLoader("Saving the data..")
        let data = gridRef.current?.api.getDataAsCsv({'exportedRows': 'all',processCellCallback: (params) => {
            // Access raw data directly from node.data
            if (params.node.data.isEdited) {
                return params.node.data[params.column.colDef.field];  
            }
            // Return null or empty string to skip non-edited rows
            return '';
            },
            shouldRowBeSkipped: (params) => {
                return !params.node.data.isEdited;
            }
        })    
        let missingFields = []
        
        const parsedData = d3.csvParse(data)
    
        parsedData.forEach((row, index) => {
            const mandatoryFields = [
                TEMPLATE_APP.APP_NAME, TEMPLATE_APP.APP_DESCRIPTION, TEMPLATE_APP.STATUS, 
                TEMPLATE_APP.ORGANIZATION, TEMPLATE_APP.AUTOMATION_TOOLS, TEMPLATE_APP.PROCESS_OWNER, 
                TEMPLATE_APP.VP, TEMPLATE_APP.GRC_CONTROL_OWNER, TEMPLATE_APP.CADENCE, 
                TEMPLATE_APP.FINANCIAL_RELEVANCE, TEMPLATE_APP.LEDGER_INFO, TEMPLATE_APP.FINANCIAL_YEAR_IMPACT, 
                TEMPLATE_APP.PDD, TEMPLATE_APP.ANNUAL_MER_SAVINGS, TEMPLATE_APP.LAUNCH_MCM
            ].filter(field => editableAppInfo.includes(field))
            mandatoryFields.forEach(field => {
                if (!row[field] || row[field].trim() === '') {
                    missingFields.push(field)
                }
            })
            if (row[TEMPLATE_APP.STATUS] === 'Active' && (!row[TEMPLATE_APP.LAUNCH_QQ_YY] || row[TEMPLATE_APP.LAUNCH_QQ_YY].trim() === '')) {
                missingFields.push(TEMPLATE_APP.LAUNCH_QQ_YY)
            }
        })
        
        if (missingFields.length > 0) {
            setAllAppsEditError(`Missing mandatory fields: ${[...new Set(missingFields)].join(', ')}`)
            setAllAppsEditLoader("")
        } else {
            configureGenericS3()
            let timeStamp = new Date().getTime().toString()
            const tenYearsFromNow = new Date();
            tenYearsFromNow.setFullYear(tenYearsFromNow.getFullYear() + 10);
            // await Storage.put('metadata.json', {'alias': userId, 'comments': showSaveAllAppsComments}, {
            //     level: "public",
            //     customPrefix: { public: `admin/allApps/${timeStamp}/` },
            //     expires: tenYearsFromNow
            // })
            const result = await uploadDocumentToVault('json', VAULT_SERVICES.ADMIN_PANEL, {"file_path": `admin/allApps/${timeStamp}/metadata.json`}, JSON.stringify({'alias': userId, 'comments': showSaveAllAppsComments}))
            // Storage.put(allAppsExportFileName, data, {
            //     level: "public",
            //     customPrefix: { public: `admin/allApps/${timeStamp}/` },
            //     expires: tenYearsFromNow
            // })
            uploadDocumentToVault('csv', VAULT_SERVICES.ADMIN_PANEL, {"file_path": `admin/allApps/${timeStamp}/${allAppsExportFileName}`}, data)
                .then((result) => {
                    setAnnotationSaveSuccessMessage("Data saved successfully. The app data will be updated in a few minutes!")
                    setAllAppsEditError(null)

                    setTimeout(() => {
                        setAnnotationSaveSuccessMessage(null)
                    }, 5000);
                    setSelectedRowIndex(null)
                    setUndoEditCount(0)
                    setMultiSelectedRow([])
                    loadAllAppsView(true)
                })
                .catch(err => setAllAppsEditError(`Saving failed: ${err}`));
        }
    }

    const onCellValueChanged = useCallback((params) => {
        const undoSize = params.api.getCurrentUndoSize();
        setUndoEditCount(undoSize)
        if (params.oldValue !== params.newValue) {
            let editedCols = params.data.isEdited || {}
            if (editedCols.hasOwnProperty(params.column.colId)) {
                // store original old value
                editedCols[params.column.colId] = { oldValue: editedCols[params.column.colId]?.oldValue, newValue: params.newValue }
            } else {
                // new entry
                editedCols[params.column.colId] = { oldValue: params.oldValue, newValue: params.newValue }
            }
            params.data.isEdited = editedCols;
        }
        params.api.refreshCells();
    }, []);

    const onCellFocused = useCallback((params) => {
        setSelectedRowIndex(params.rowIndex)
    }, []);

    const onSelectionChanged = (param) => {
        const selectedNodes = gridRef.current.api.getSelectedNodes();
        const selectedData = selectedNodes.map(node => ({
          rowIndex: node.rowIndex,
          data: node.data
        }));
        setMultiSelectedRow(selectedData.sort((a, b) => b.rowIndex - a.rowIndex))
      };

    const onColumnRowGroupChanged = useCallback(() => {
        setRowGroupColumns(gridRef?.current?.api?.getRowGroupColumns())
    }, [])

    const exportAllApps = (args = {}) => {
        let csv = gridRef.current?.api.exportDataAsCsv({
            'fileName': allAppsExportFileName,
            'exportedRows': args.filtered ? 'filteredAndSorted' : 'all',
            'onlySelected': args.selectedOnly,
            processCellCallback: (params) => {
                // Access raw data directly from node.data
                if (params.node.group) {
                    // Access grouped value
                    return params.value;
                } else {
                    const rawValue = params.node.data[params.column.colDef.field];
                    return rawValue;
                }

            }
        });
        // gridRef.current?.api.exportDataAsExcel()
    }

    function closeSaveAllAppsModal(){
        setShowSaveAllAppsModal(false);
        setShowSaveAllAppsComments(null);
    }

    const addNewApp = (data = {}) => {
        let copy = Object.assign({}, data)
        copy['isNew'] = true
        allApps.splice(0, 0, copy);
        setAllApps([...allApps])
        setUndoEditCount(undoEditCount + 1)
    }        

    const updateValue = (fieldName, value) => {
        fieldMetadata[fieldName]['values'] = value
    }

    const getSelectFieldValues = (fieldName, subKey = null) => {
        if (fieldMetadata && fieldMetadata[fieldName] && fieldMetadata[fieldName]['values']) {
            return fieldMetadata[fieldName]['values']
        } else if (subKey && fieldMetadata && fieldMetadata[fieldName][subKey] && fieldMetadata[fieldName][subKey]['values']) {
            return fieldMetadata[fieldName][subKey]['values']
        } else {
            return []
        }
    }

    const setLoader = (key, value) => {
        let obj = {}
        obj[key] = value
        setLoaders(prevState => {
            return {...prevState, ...obj};
          });
    }

    const setReloaders = (key, value) => {
        let obj = {}
        obj[key] = value
        setReloadNotifiers(prevState => {
            return {...prevState, ...obj};
          });

    }

    const setError = (key, value) => {
        let obj = {}
        obj[key] = value
        setErrorMessages(prevState => {
            return {...prevState, ...obj};
          });
    }

    const loadMetadataForType =  async(key) =>{
        let res = await getEditableFields();
        fieldMetadata[key] = res[key]
        // setFieldMetadata(prevState => {
        //     return {...prevState, ...fieldMetadata};
        //   });
    }

    const updateMetadata = (key) => {
        setLoader(key, true)
        setMetadataValues({ type: getLabelToFieldTypeMappers()[key], values: fieldMetadata[key]['values'] },
            function onSuccess(response) { 
                setError(key, null)
                refresh(key)
                },
            function onFailure(errorResponse) { 
                setError(key,"Cannot update metadata values")
                errorResponse.errors.forEach((error) => {
                    if(error.message.includes("violates foreign key constraint")){
                        setError(key, `Cannot remove one of the ${key} because there is an app that is linked to this ${key}.\nHowever, you can update the values of an existing entry - This will reflect on the existing linked apps`)
                    }
                })
                refresh(key)
             })
    }

    const refresh = async (key) => {
        setLoader(key, true)
        setReloaders(key, false)
        await loadMetadataForType(key) 
        setLoader(key, false)
        setReloaders(key, true)
    }

    // Helper function to extract unique users from all apps
    const extractUniqueUsersFromApps = () => {
        const uniqueUsers = new Set();
        
        allApps.forEach(app => {
            // Add GRC control owners
            if (app[TEMPLATE_APP.GRC_CONTROL_OWNER] && Array.isArray(app[TEMPLATE_APP.GRC_CONTROL_OWNER])) {
                app[TEMPLATE_APP.GRC_CONTROL_OWNER].forEach(user => {
                    if (user && user.trim()) uniqueUsers.add(user.trim());
                });
            }
            
            // Add Process owners
            if (app[TEMPLATE_APP.PROCESS_OWNER] && Array.isArray(app[TEMPLATE_APP.PROCESS_OWNER])) {
                app[TEMPLATE_APP.PROCESS_OWNER].forEach(user => {
                    if (user && user.trim()) uniqueUsers.add(user.trim());
                });
            }
            
            // Add VPs
            if (app[TEMPLATE_APP.VP] && Array.isArray(app[TEMPLATE_APP.VP])) {
                app[TEMPLATE_APP.VP].forEach(user => {
                    if (user && user.trim()) uniqueUsers.add(user.trim());
                });
            }
        });

        return Array.from(uniqueUsers);
    };

    // Helper function to check if user is in specific field of an app
    const isUserInAppField = (userLogin, app, fieldType) => {
        const fieldData = app[fieldType] || [];
        return fieldData.some(user => user && user.trim().toLowerCase() === userLogin.toLowerCase());
    };

    // Helper function to create user row data
    const createUserRow = (field, app, userLogin, additionalData = {}) => {
        return {
            field,
            app_id: app[TEMPLATE_APP.APP_ID],
            app_name: app[TEMPLATE_APP.APP_NAME],
            alias: userLogin,
            ...additionalData
        };
    };

    // Helper function to create standard column definitions
    const createStandardColumns = (customColumns = []) => {
        const baseColumns = [
            {
                field: 'field',
                headerName: 'Field',
                resizable: true,
                sortable: true,
                filter: true,
                filterParams: {
                    closeOnApply: false,
                    buttons: ['apply', 'clear'],
                    defaultOption: 'contains'
                }
            }
        ];

        return [...baseColumns, ...customColumns];
    };

    const loadInactiveUsersReport = async () => {
        if (!hasAdminAccess || !allApps) return;
        
        setInactiveUsersLoader(true);
        setInactiveUsersError(null);
        
        try {
            // Use helper function to get unique users
            const usersList = extractUniqueUsersFromApps();
            
            // Use the PAPI API to get all employee information (including inactive)
            const allEmployees = await getEmployeesByLoginList(usersList, 1000);
            
            // Create individual rows for each inactive user using PAPI response
            const inactiveUserRows = [];
            
            allEmployees.forEach(emp => {
                // Check if user is inactive (jobStatus !== 'A')
                if (emp.basicInfo.jobStatus !== 'A') {
                    const userLogin = emp.basicInfo.login.toLowerCase();
                        
                    allApps.forEach(app => {
                        const grcOwners = app[TEMPLATE_APP.GRC_CONTROL_OWNER] || [];
                        const processOwners = app[TEMPLATE_APP.PROCESS_OWNER] || [];
                        const vps = app[TEMPLATE_APP.VP] || [];
                        
                        // Use helper function to check fields and create rows with for loop
                        for (const fieldType of userFieldTypes) {
                            if (isUserInAppField(userLogin, app, fieldType.field)) {
                                inactiveUserRows.push(createUserRow(fieldType.label, app, userLogin, {
                                    status: emp.basicInfo.jobStatus === 'I' ? 'Inactive' : emp.basicInfo.jobStatus,
                                    last_known_manager: emp.basicInfo.managerLogin || 'Unknown',
                                    app_status: app[TEMPLATE_APP.STATUS] || 'Unknown'
                                }));
                            }
                        }
                    });
                }
            });

            // Also check for users not found in PAPI at all
            const foundLogins = new Set(allEmployees.map(emp => emp.basicInfo.login.toLowerCase()));
            
            allApps.forEach(app => {
                const grcOwners = app[TEMPLATE_APP.GRC_CONTROL_OWNER] || [];
                const processOwners = app[TEMPLATE_APP.PROCESS_OWNER] || [];
                const vps = app[TEMPLATE_APP.VP] || [];
                
                // Check for users not found in PAPI
                [...grcOwners, ...processOwners, ...vps].forEach((user, index) => {
                    if (user && user.trim() && user.trim() !== '' && !foundLogins.has(user.trim().toLowerCase())) {
                        const field = index < grcOwners.length ? 'GRC Control Owner' : 
                                     index < grcOwners.length + processOwners.length ? 'Process Owner' : 'VP';
                        
                        inactiveUserRows.push({
                            field: field,
                            app_id: app[TEMPLATE_APP.APP_ID],
                            app_name: app[TEMPLATE_APP.APP_NAME],
                            alias: user.trim(),
                            status: 'Not Found',
                            last_known_manager: 'Not Found',
                            app_status: app[TEMPLATE_APP.STATUS] || 'Unknown'
                        });
                    }
                });
            });

            setInactiveUsersData(inactiveUserRows);

            // Set up columns for the inactive users format using helper function
            const inactiveUsersColumns = createStandardColumns([
                {
                    field: 'app_id',
                    headerName: 'App ID',
                    resizable: true,
                    sortable: true,
                    filter: true,
                    filterParams: {
                        closeOnApply: false,
                        buttons: ['apply', 'clear'],
                        defaultOption: 'contains'
                    }
                },
                {
                    field: 'app_name',
                    headerName: 'App Name',
                    resizable: true,
                    sortable: true,
                    filter: true,
                    autoSizeColumns: true,
                    flex: 1,
                    minWidth: 200,
                    filterParams: {
                        closeOnApply: false,
                        buttons: ['apply', 'clear'],
                        defaultOption: 'contains'
                    }
                },
                {
                    field: 'app_status',
                    headerName: 'App Status',
                    resizable: true,
                    sortable: true,
                    filter: true,
                    filterParams: {
                        closeOnApply: false,
                        buttons: ['apply', 'clear'],
                        defaultOption: 'contains'
                    }
                },
                {
                    field: 'alias',
                    headerName: 'Alias',
                    resizable: true,
                    sortable: true,
                    filter: true,
                    filterParams: {
                        closeOnApply: false,
                        buttons: ['apply', 'clear'],
                        defaultOption: 'contains'
                    }
                },
                {
                    field: 'status',
                    headerName: 'User Status',
                    resizable: true,
                    sortable: true,
                    filter: true,
                    filterParams: {
                        closeOnApply: false,
                        buttons: ['apply', 'clear'],
                        defaultOption: 'contains'
                    }
                },
                {
                    field: 'last_known_manager',
                    headerName: 'Last known manager',
                    resizable: true,
                    sortable: true,
                    filter: true,
                    filterParams: {
                        closeOnApply: false,
                        buttons: ['apply', 'clear'],
                        defaultOption: 'contains'
                    }
                }
            ]);

            setInactiveUsersColumnsList(inactiveUsersColumns);

        } catch (error) {
            console.error('Error loading inactive users report:', error);
            setInactiveUsersError('Failed to load inactive users report: ' + error.message);
        } finally {
            setInactiveUsersLoader(false);
        }
    };

    const exportInactiveUsers = () => {
        if (inactiveUsersData && inactiveUsersData.length > 0) {
            const headers = ['Field', 'App ID', 'App Name', 'App Status', 'Alias', 'User Status', 'Last known manager'];
            const data = inactiveUsersData.map(user => ({
                'Field': user.field,
                'App ID': user.app_id,
                'App Name': user.app_name,
                'App Status': user.app_status,
                'Alias': user.alias,
                'User Status': user.status,
                'Last known manager': user.last_known_manager
            }));
            constructExcelSheetWithHeadersAndData(headers, data, 'Inactive Users');
        }
    };

    const loadOutsideCostCenterReport = async () => {
        if (!hasAdminAccess || !allApps) return;
        
        setOutsideCostCenterLoader(true);
        setOutsideCostCenterError(null);
        
        try {
            // Use helper function to get unique users
            const usersList = extractUniqueUsersFromApps();
            
            // Use the PAPI API to get all employee information
            const allEmployees = await getEmployeesByLoginList(usersList, 1000);
            
            // Create individual rows for users who are active but not in allowed cost centers
            const outsideCostCenterRows = [];
            
            allEmployees.forEach(emp => {
                // Check if user is active but not in allowed cost centers
                if (emp.basicInfo.jobStatus === 'A' && !allowedCostCenters.includes(emp.basicInfo.costCenterId)) {
                    const userLogin = emp.basicInfo.login.toLowerCase();
                        
                    allApps.forEach(app => {
                        const grcOwners = app[TEMPLATE_APP.GRC_CONTROL_OWNER] || [];
                        const processOwners = app[TEMPLATE_APP.PROCESS_OWNER] || [];
                        const vps = app[TEMPLATE_APP.VP] || [];
                        
                        // Use for loop to check all field types
                        for (const fieldType of userFieldTypes) {
                            if (isUserInAppField(userLogin, app, fieldType.field)) {
                                outsideCostCenterRows.push({
                                    field: fieldType.label,
                                    app: app[TEMPLATE_APP.APP_ID],
                                    app_name: app[TEMPLATE_APP.APP_NAME],
                                    alias: userLogin,
                                    employee_cost_centre: `${emp.basicInfo.costCenterId} - ${emp.basicInfo.costCenterName || 'Unknown'}`,
                                    app_status: app[TEMPLATE_APP.STATUS] || 'Unknown'
                                });
                            }
                        }
                    });
                }
            });

            setOutsideCostCenterData(outsideCostCenterRows);

            // Set up columns for the outside cost center format using helper function
            const outsideCostCenterColumns = createStandardColumns([
                {
                    field: 'app',
                    headerName: 'App',
                    resizable: true,
                    sortable: true,
                    filter: true,
                    filterParams: {
                        closeOnApply: false,
                        buttons: ['apply', 'clear'],
                        defaultOption: 'contains'
                    }
                },
                {
                    field: 'app_name',
                    headerName: 'App Name',
                    resizable: true,
                    sortable: true,
                    filter: true,
                    flex: 1,
                    minWidth: 200,
                    filterParams: {
                        closeOnApply: false,
                        buttons: ['apply', 'clear'],
                        defaultOption: 'contains'
                    }
                },
                {
                    field: 'app_status',
                    headerName: 'App Status',
                    resizable: true,
                    sortable: true,
                    filter: true,
                    filterParams: {
                        closeOnApply: false,
                        buttons: ['apply', 'clear'],
                        defaultOption: 'contains'
                    }
                },
                {
                    field: 'alias',
                    headerName: 'Alias',
                    resizable: true,
                    sortable: true,
                    filter: true,
                    filterParams: {
                        closeOnApply: false,
                        buttons: ['apply', 'clear'],
                        defaultOption: 'contains'
                    }
                },
                {
                    field: 'employee_cost_centre',
                    headerName: 'Employee Cost Centre',
                    resizable: true,
                    sortable: true,
                    filter: true,
                    filterParams: {
                        closeOnApply: false,
                        buttons: ['apply', 'clear'],
                        defaultOption: 'contains'
                    }
                }
            ]);

            setOutsideCostCenterColumnsList(outsideCostCenterColumns);

        } catch (error) {
            console.error('Error loading outside cost center report:', error);
            setOutsideCostCenterError('Failed to load outside cost center report: ' + error.message);
        } finally {
            setOutsideCostCenterLoader(false);
        }
    };

    const loadArchivedApps = async () => {
        setArchivedAppsLoading(true);
        getAutomatedAppsByStatus("ARCHIVED",
            (result) => {
                const rawData = result?.data?.getAutomatedAppsByStatus;
                const parsed = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
                const items = parsed?.items || parsed || [];
                setArchivedApps(items);
                setArchivedAppsLoading(false);
            },
            (error) => {
                console.error("Error fetching archived apps:", error);
                setArchivedApps([]);
                setArchivedAppsLoading(false);
            }
        );
    };

    const checkAiAdminAccess = async () => {
        if (userId && currentStage) {
            const aiAccess = await getAccessLevel(userId, TEMPLATES.AI, currentStage);
            const isAiAdmin = ADD_APP_ACCESS_LEVELS.includes(aiAccess?.appAccessLevel);
            setHasAiAdminAccess(isAiAdmin);
            setAiAdminCheckDone(true);
            if (isAiAdmin || hasAdminAccess) {
                loadArchivedApps();
                // Load metadata for AI repo admins (needed for dropdown editing)
                if (isAiAdmin && !hasAdminAccess && !fieldMetadata?.[AI_APP_SPECIFIC_FIELDS.AUTOMATION_TOOL]) {
                    let res = await getEditableFields();
                    setFieldMetadata(prev => ({ ...prev, ...res }));
                }
            }
        }
    };

    const AI_APP_REQUIRED_HEADERS = ["app_name", "app_description", "ai_use_case_type", "solution_type", "organization", "ai_automation_tool", "app_owner", "director", "grc_control_owner", "vp", "region", "annual_mer_savings", "sox_impact", "application_link", "overview_content"];

    const loadMetricsDashboard = async () => {
        if (!userId || !currentStage) return; // wait for auth state
        setMetricsLoading(true);
        setMetricsError(null);
        setMetricsAccessDenied(false);
        try {
            const [isPortalAdmin, isSupportAdmin] = await Promise.all([
                checkIfPortalAdmin(userId, currentStage),
                checkIfSupportAdmin(userId, currentStage)
            ]);
            if (!isPortalAdmin && !isSupportAdmin) {
                setMetricsAccessDenied(true);
            }
        } catch (error) {
            console.error("Error loading metrics dashboard:", error);
            setMetricsError("Failed to load metrics dashboard: " + (error.message || "Unknown error"));
        } finally {
            setMetricsAccessChecked(true);
            setMetricsLoading(false);
        }
    };

    // Gate the RAISE Curriculum admin surface on RAISE admin access (RAISE_ADMINS
    // group, or portal/support admin fallback) — mirrors the metrics gate.
    const loadRaiseAccess = async () => {
        if (!userId || !currentStage) return; // wait for auth state
        setRaiseAccessLoading(true);
        setRaiseAccessDenied(false);
        try {
            const isRaiseAdmin = await checkIfRaiseAdmin(userId, currentStage);
            if (!isRaiseAdmin) {
                setRaiseAccessDenied(true);
            }
        } catch (error) {
            console.error("Error checking RAISE admin access:", error);
            setRaiseAccessDenied(true);
        } finally {
            setRaiseAccessChecked(true);
            setRaiseAccessLoading(false);
        }
    };
    const AI_APP_OPTIONAL_HEADERS = ["tags", "permissions_link", "grc_link", "demo_video_url", "sop_url", "pdd", "app_owning_ldap", "support_contact_name", "support_email"];
    const AI_APP_ALL_HEADERS = [...AI_APP_REQUIRED_HEADERS, ...AI_APP_OPTIONAL_HEADERS];

    const handleBulkCsvUpload = (file) => {
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (e) => {
            const csvText = e.target.result;
            const parsed = d3.csvParse(csvText);
            if (!parsed || parsed.length === 0) {
                setBulkUploadErrors(["File is empty or could not be parsed."]);
                setBulkUploadData(null);
                return;
            }
            // Validate headers
            const fileHeaders = Object.keys(parsed[0] || {});
            const missingHeaders = AI_APP_REQUIRED_HEADERS.filter(h => !fileHeaders.includes(h));
            if (missingHeaders.length > 0) {
                setBulkUploadErrors([`Missing required headers: ${missingHeaders.join(", ")}`]);
                setBulkUploadData(null);
                return;
            }
            const unknownHeaders = fileHeaders.filter(h => !AI_APP_ALL_HEADERS.includes(h));
            const warnings = unknownHeaders.length > 0 ? [`Unknown headers (will be ignored): ${unknownHeaders.join(", ")}`] : [];
            // Validate rows
            const rowErrors = [];
            parsed.forEach((row, idx) => {
                const missing = AI_APP_REQUIRED_HEADERS.filter(h => !row[h] || row[h].trim() === "");
                if (missing.length > 0) {
                    rowErrors.push(`Row ${idx + 1}: Missing required fields: ${missing.join(", ")}`);
                }
            });
            setBulkUploadErrors([...warnings, ...rowErrors]);
            setBulkUploadData(parsed);
        };
        reader.readAsText(file);
    };

    const executeBulkUpload = async () => {
        if (!bulkUploadData || bulkUploadData.length === 0) return;
        setBulkUploadLoading(true);
        setBulkUploadProgress(0);
        setBulkUploadResult(null);
        setBulkUploadModalVisible(true);
        let successCount = 0;
        let failCount = 0;
        const errors = [];

        const parseErrorMessage = (err) => {
            const msg = err?.errors?.[0]?.message || err?.message || JSON.stringify(err);
            // Parse common SQL/API errors into friendly messages
            if (msg.includes("null value in column") && msg.includes("app_attributes")) {
                const match = msg.match(/Failing row contains \(\d+, null, (.+?)\)/);
                const field = match ? match[1].toLowerCase().replace(/_/g, ' ') : "unknown field";
                return `Invalid value for "${field}" — value not found in allowed options. Check Admin Panel for valid values.`;
            }
            if (msg.includes("duplicate key") || msg.includes("already exists")) {
                return "An app with this name already exists.";
            }
            if (msg.includes("null value in column")) {
                const match = msg.match(/column "(.+?)"/);
                return `Missing required field: ${match ? match[1] : "unknown"}`;
            }
            if (msg.includes("WrongType") || msg.includes("contains a field not in")) {
                const match = msg.match(/contains a field not in '(.+?)': '(.+?)'/);
                return match ? `Unknown field "${match[2]}" not allowed in schema.` : "Invalid field in input.";
            }
            // Truncate long raw errors
            return msg.length > 150 ? msg.substring(0, 150) + "..." : msg;
        };

        for (let i = 0; i < bulkUploadData.length; i++) {
            const row = bulkUploadData[i];
            // Build app data from row
            const appData = {};
            AI_APP_ALL_HEADERS.forEach(h => {
                if (row[h] && row[h].trim() !== "") {
                    // Multi-value fields (comma-separated in CSV)
                    if (["organization", "region", "tags", "director", "grc_control_owner", "vp", "app_owner", "app_owning_ldap"].includes(h)) {
                        appData[h] = row[h].split(",").map(v => v.trim()).filter(v => v);
                    } else {
                        appData[h] = row[h].trim();
                    }
                }
            });
            appData.template_id = "01KFGM42NV7QX58RWBZ3HP6YAT";
            appData.status = "Active";
            appData.created_by = userId;
            appData.last_updated_by = userId;
            appData.app_ingestion_method = "Manual Bulk Upload";

            try {
                await new Promise((resolve, reject) => {
                    addAIApp(appData, (res) => resolve(res), (err) => reject(err));
                });
                successCount++;
            } catch (err) {
                failCount++;
                errors.push(`Row ${i + 1} (${row.app_name}): ${parseErrorMessage(err)}`);
            }
            setBulkUploadProgress(i + 1);
            // Yield to React render cycle so progress bar updates visually
            await new Promise(r => setTimeout(r, 0));
        }

        // Clear apps cache and set a "no-cache" window so marketplace doesn't 
        // re-cache stale data from the read replica during the replication lag period
        if (successCount > 0) {
            localStorage.removeItem(GET_APPS_CACHE_KEY);
            // Prevent caching for 60 seconds (replica lag window)
            localStorage.setItem('appsCacheBypassUntil', String(Date.now() + 60000));
        }

        setBulkUploadResult({ successCount, failCount, errors });
        setBulkUploadLoading(false);
    };

    const exportOutsideCostCenterUsers = () => {
        if (outsideCostCenterData && outsideCostCenterData.length > 0) {
            const headers = ['Field', 'App', 'App Name', 'App Status', 'Alias', 'Employee Cost Centre'];
            const data = outsideCostCenterData.map(user => ({
                'Field': user.field,
                'App': user.app,
                'App Name': user.app_name,
                'App Status': user.app_status,
                'Alias': user.alias,
                'Employee Cost Centre': user.employee_cost_centre
            }));
            constructExcelSheetWithHeadersAndData(headers, data, 'Cost Centres outside of FGBS');
        }
    };

    const getQuarterRange = (quarter, year) => {
        const quarterNum = parseInt(quarter.replace('Q', ''));
        const startMonth = (quarterNum - 1) * 3;

        const start = new Date(year, startMonth, 1, 0, 0, 0, 0);
        const end = new Date(year, startMonth + 3, 0, 23, 59, 59, 999);

        return {
            start: start.getTime(),
            end: end.getTime()
        };
    };

    const downloadAuditLogsByRange = (containsKey) => {
        let range = getQuarterRange(selectedAuditLogQuarter.value, selectedAuditLogYear.value)
        let csvRows = [];
        let headers = null;
        setShowAuditLoader([{message:'Preparing...', type:'loading'}])
        
        listLogsByIdWithTimeFilterContainingPK(containsKey, range.start, range.end, function onStream(items){
            items.forEach(item => {
                if (!headers) {
                    headers = Object.keys(item).join(',');
                    csvRows.push(headers);
                }
                csvRows.push(Object.values(item).map(val => {
                    const stringVal = typeof val === 'object' ? JSON.stringify(val) : String(val);
                    return `"${stringVal.replace(/"/g, '""')}"`;
                }).join(','));
            });
            setShowAuditLoader([{message:`Preparing... Total items ${csvRows?.length}`, type:'loading'}, {message:'Do not navigate away from the page while preparing.', type:'warning'}])
        }, function onComplete(){
            const csvContent = csvRows.join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Audit_logs_${containsKey}_${selectedAuditLogQuarter.value}_${selectedAuditLogYear.value}.csv`;
            a.click();
            URL.revokeObjectURL(url);
            setShowAuditLoader(null)
        }, function onFailure(){
            setShowAuditLoader([{message:'Failed to fetch the logs!', type:'error'}])
        })
    }

    const downloadFRISCOLogs = () => {
        downloadAuditLogsByRange('FRISCO')
    }

    const downloadFRISCOMetadataLogs= () => {
        downloadAuditLogsByRange('FRISCO#')
    }

    const getView = (label, type, allowAiAdmin = false) => {
        const hasAccess = allowAiAdmin ? (hasAdminAccess || hasAiAdminAccess) : hasAdminAccess;
        return (
            <ExpandableSection
                variant="container"
                defaultExpanded={false}
                headerText={label}
                headerActions={<Button iconName="refresh" variant="icon" onClick={() =>{ 
                        refresh(type)
                }}></Button>}
            >
                
                {
                    hasAccess ? <>
                    {
                     fieldMetadata[type] ?
                        <>
                            {loaders && loaders[type] ? <Box>
                                <span>Please wait...</span> <Spinner />
                            </Box> : ''}

                            {errorMessages[type] ? <Box>
                                <span className="errorMessage">{errorMessages[type]}</span>
                            </Box> : ''}

                            <CustomMultiInputAdminForSelect reloadNotifiers={reloadNotifiers} setReloadNotifier={setReloaders} 
                            field={type} updateValue={updateValue} getValues={getSelectFieldValues}></CustomMultiInputAdminForSelect>
                            <Box float="right">
                                <Button variant="primary" disabled={loaders[type] ? true : false} onClick={() => updateMetadata(type)}>Save</Button>
                            </Box>

                        </> : ''
                }
                    </> : <AccessDenied appName="Admin panel"></AccessDenied>
                }

            </ExpandableSection>
        )
    }

    const Content = (
        <>
            {showLoadingIcon ? (
                <Modal visible={showLoadingIcon}>
                    <Box>
                        <Spinner></Spinner>
                        Loading...
                    </Box>
                </Modal>
            ) : new URLSearchParams(location.search).get("tab") === "raise-admin-panel" ? (
                (!raiseAccessChecked || raiseAccessLoading) ? (
                    <Box textAlign="center" padding={{ top: "xxxl" }}><Spinner size="large" /> Checking access...</Box>
                ) : raiseAccessDenied ? (
                    <ErrorComponent header="Access Denied" message="You do not have access to the RAISE admin. Only RAISE Admins (and Portal Admins) can edit the curriculum." />
                ) : (
                <>
                <div className="mainPage">
                    <ContentLayout
                        headerVariant="high-contrast"
                        header={
                            <SpaceBetween size="m">
                                {/* Full-width top spacer: adds breathing room above
                                    the title without constraining the header width
                                    (a Box padding wrapper shrinks the dark band). */}
                                <div style={{ height: "12px" }} />
                                <Header
                                    variant="h1"
                                    description="Manage the RAISE curriculum — courses, calendar, certifications, FAQ, and lookup lists."
                                    actions={
                                        <Button
                                            iconName="view-full"
                                            iconAlign="right"
                                            onClick={() => setShowRaisePreview(true)}
                                        >
                                            Preview
                                        </Button>
                                    }
                                >
                                    RAISE Admin Panel
                                </Header>
                            </SpaceBetween>
                        }
                    >
                        {/* Dark (high-contrast) header for the title only; the tabbed
                            content sits on a light surface pushed below the dark
                            band (white background + top padding). Full width kept —
                            no Container wrapper. */}
                        <div style={{ background: "#ffffff", borderRadius: "16px", padding: "20px", marginTop: "12px" }}>
                            <RaiseAdmin />
                        </div>
                    </ContentLayout>
                </div>
                {/* Rendered OUTSIDE the ContentLayout: nesting the modal inside the
                    high-contrast layout made opening/closing it collapse the dark
                    header width. */}
                {showRaisePreview && (
                    <Modal
                        visible
                        size="max"
                        onDismiss={() => setShowRaisePreview(false)}
                        header="RAISE — preview"
                        footer={
                            <Box float="right">
                                <Button variant="primary" onClick={() => setShowRaisePreview(false)}>
                                    Close
                                </Button>
                            </Box>
                        }
                    >
                        {/* The modal is conditionally rendered, so RaiseHome
                            already mounts fresh (and reloads its own data) each
                            time the preview opens. No key needed — a Date.now()
                            key would re-evaluate on every AdminPanel render and
                            force a full remount/refetch on any unrelated state
                            change while the modal is open. */}
                        <RaiseHome embedded />
                    </Modal>
                )}
                </>
                )
            ) : new URLSearchParams(location.search).get("tab") === "metrics" ? (
                (!metricsAccessChecked || metricsLoading) ? (
                    <Box textAlign="center" padding={{ top: "xxxl" }}><Spinner size="large" /> Loading metrics dashboard...</Box>
                ) : metricsAccessDenied ? (
                    <ErrorComponent header="Access Denied" message="You do not have access to the Metrics dashboard. Only Portal Admins and Support Admins can view this page." />
                ) : metricsError ? (
                    <ErrorComponent header="Error" message={metricsError} />
                ) : (
                    <div className="mainPage">
                        <ContentLayout
                            headerVariant="high-contrast"
                            header={
                                <SpaceBetween size="m">
                                    <Header variant="h1" description="Portal metrics dashboard.">
                                        Metrics
                                    </Header>
                                </SpaceBetween>
                            }
                        >
                            <Container>
                                <iframe
                                    width="100%"
                                    height="1100"
                                    style={{ border: "none", minHeight: "calc(100vh - 250px)" }}
                                    src="https://us-east-1.quicksight.aws.amazon.com/sn/account/fgbsbi/embed/share/accounts/597646755921/dashboards/912fdf9d-0d82-41a6-b321-6091c8251349"
                                    title="Metrics Dashboard"
                                ></iframe>
                            </Container>
                        </ContentLayout>
                    </div>
                )
            ) : new URLSearchParams(location.search).get("tab") === "ai-repo-control-panel" ? (
                (!aiAdminCheckDone && !hasAdminAccess) ? (
                    <Box textAlign="center" padding={{ top: "xxxl" }}><Spinner size="large" /> Checking access...</Box>
                ) : (hasAiAdminAccess || hasAdminAccess) ? (
                <div className="mainPage">
                    <ContentLayout
                        headerVariant="high-contrast"
                        header={
                            <SpaceBetween size="m">
                                <Header variant="h1" description="Manage AI Repository applications.">
                                    AI Repo Control Panel
                                </Header>
                            </SpaceBetween>
                        }
                    >
                        <SpaceBetween size="xl">
                        {/* AI Metadata Dropdowns */}
                        <Container header={<Header variant="h3">AI App Metadata</Header>}>
                            <ColumnLayout columns={3}>
                                {[
                                    {key: AI_APP_SPECIFIC_FIELDS.AUTOMATION_TOOL, label: 'AI Automation Tool'},
                                    {key: AI_APP_SPECIFIC_FIELDS.USE_CASE_TYPE, label: 'AI Use Case Type'},
                                    {key: AI_APP_SPECIFIC_FIELDS.SOLUTION_TYPE, label: 'AI Solution Type'},
                                    {key: AI_APP_SPECIFIC_FIELDS.SOX_IMPACT, label: 'AI SOX Impact'},
                                    {key: AI_APP_SPECIFIC_FIELDS.TAGS, label: 'AI Tags'},
                                ].map((item) => getView(item.label, item.key, true))}
                            </ColumnLayout>
                        </Container>

                        {/* Bulk Add Section */}
                        <Container
                            header={<Header variant="h3">Bulk Add AI Applications</Header>}
                        >
                            <SpaceBetween size="l">
                                <Box>
                                    <SpaceBetween size="s">
                                        <Box variant="p" color="text-body-secondary">Upload a CSV file to bulk-add AI applications directly to the marketplace. <Button variant="link" onClick={() => {
                                            const csv = AI_APP_ALL_HEADERS.join(",") + "\n";
                                            const blob = new Blob([csv], { type: "text/csv" });
                                            const url = URL.createObjectURL(blob);
                                            const a = document.createElement("a");
                                            a.href = url;
                                            a.download = "ai_app_bulk_upload_template.csv";
                                            a.click();
                                            URL.revokeObjectURL(url);
                                        }}>Download CSV Template</Button></Box>
                                        <ExpandableSection headerText="View valid values for dropdown fields" variant="footer">
                                            <SpaceBetween size="m">
                                                {[
                                                    { key: AI_APP_SPECIFIC_FIELDS.USE_CASE_TYPE, label: "ai_use_case_type" },
                                                    { key: AI_APP_SPECIFIC_FIELDS.SOLUTION_TYPE, label: "solution_type" },
                                                    { key: AI_APP_SPECIFIC_FIELDS.AUTOMATION_TOOL, label: "ai_automation_tool" },
                                                    { key: AI_APP_SPECIFIC_FIELDS.SOX_IMPACT, label: "sox_impact" },
                                                    { key: AI_APP_SPECIFIC_FIELDS.TAGS, label: "tags" },
                                                    { key: TEMPLATE_APP.ORGANIZATION, label: "organization" },
                                                    { key: TEMPLATE_APP.REGION, label: "region" },
                                                ].map(({ key, label }) => (
                                                    <Box key={label}>
                                                        <Box variant="awsui-key-label" margin={{ bottom: "xxs" }}>{label}</Box>
                                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                                                            {(fieldMetadata?.[key]?.values || []).map((v, i) => {
                                                                const val = v.label || v.value || v;
                                                                return <Badge key={i} color="blue">{val}</Badge>;
                                                            })}
                                                            {!fieldMetadata?.[key]?.values && <Badge color="grey">Loading...</Badge>}
                                                        </div>
                                                    </Box>
                                                ))}
                                            </SpaceBetween>
                                        </ExpandableSection>
                                        <FileUpload
                                            onChange={({ detail }) => {
                                                if (detail.value?.[0]) {
                                                    handleBulkCsvUpload(detail.value[0]);
                                                }
                                            }}
                                            value={[]}
                                            accept=".csv"
                                            i18nStrings={{
                                                uploadButtonText: () => "Choose CSV file",
                                                dropzoneText: () => "Drop CSV file here",
                                                removeFileAriaLabel: (e) => `Remove file ${e + 1}`,
                                                errorIconAriaLabel: "Error"
                                            }}
                                            multiple={false}
                                        />
                                    </SpaceBetween>
                                </Box>

                                {bulkUploadErrors.length > 0 && (
                                    <Alert type={bulkUploadData ? "warning" : "error"}>
                                        <SpaceBetween size="xxs">
                                            {bulkUploadErrors.map((err, i) => <Box key={i} fontSize="body-s">{err}</Box>)}
                                        </SpaceBetween>
                                    </Alert>
                                )}

                                {bulkUploadData && bulkUploadData.length > 0 && (
                                    <SpaceBetween size="m">
                                        <Header variant="h4" counter={`(${bulkUploadData.length} rows)`}>Preview</Header>
                                        <div style={{ width: "100%", height: "400px" }} className="ag-theme-alpine">
                                            <AgGridReact
                                                rowData={bulkUploadData}
                                                columnDefs={AI_APP_ALL_HEADERS.filter(h => bulkUploadData[0]?.hasOwnProperty(h)).map(h => ({
                                                    field: h,
                                                    headerName: h,
                                                    filter: true,
                                                    sortable: true,
                                                    resizable: true,
                                                    minWidth: 120,
                                                    cellClass: (params) => {
                                                        if (AI_APP_REQUIRED_HEADERS.includes(h) && (!params.value || params.value.trim() === "")) {
                                                            return "edited-row";
                                                        }
                                                        return "";
                                                    }
                                                }))}
                                                defaultColDef={{ resizable: true, sortable: true, filter: true, floatingFilter: true }}
                                                animateRows={true}
                                                pagination={true}
                                                paginationPageSize={20}
                                            />
                                        </div>
                                        <Box float="right">
                                            <SpaceBetween direction="horizontal" size="xs">
                                                <Button onClick={() => { setBulkUploadData(null); setBulkUploadErrors([]); setBulkUploadResult(null); }}>Cancel</Button>
                                                {bulkUploadErrors.some(e => e.startsWith("Missing required") || e.startsWith("Row ")) ? (
                                                    <Popover
                                                        content={<Box fontSize="body-s" color="text-status-error">Fix validation errors above before publishing: {bulkUploadErrors.filter(e => e.startsWith("Row ")).length} row(s) have missing required fields.</Box>}
                                                        dismissButton={false}
                                                        position="top"
                                                        size="medium"
                                                        triggerType="custom"
                                                    >
                                                        <Button variant="primary" disabled={true}>
                                                            {`Publish ${bulkUploadData.length} Apps`}
                                                        </Button>
                                                    </Popover>
                                                ) : (
                                                    <Button variant="primary" loading={bulkUploadLoading} disabled={bulkUploadLoading} onClick={executeBulkUpload}>
                                                        {bulkUploadLoading ? `Publishing... (${bulkUploadProgress}/${bulkUploadData.length})` : `Publish ${bulkUploadData.length} Apps`}
                                                    </Button>
                                                )}
                                            </SpaceBetween>
                                        </Box>
                                        {bulkUploadModalVisible && (
                                            <Modal
                                                visible={true}
                                                header={bulkUploadLoading ? "Publishing Apps" : "Bulk Upload Complete"}
                                                size="large"
                                                onDismiss={() => { if (!bulkUploadLoading) setBulkUploadModalVisible(false); }}
                                                footer={!bulkUploadLoading ? (
                                                    <Box float="right">
                                                        <Button variant="primary" onClick={() => setBulkUploadModalVisible(false)}>Close</Button>
                                                    </Box>
                                                ) : null}
                                            >
                                                <SpaceBetween size="l">
                                                    <ProgressBar
                                                        value={Math.round((bulkUploadProgress / (bulkUploadData?.length || 1)) * 100)}
                                                        status={bulkUploadLoading ? "in-progress" : (bulkUploadResult?.failCount === 0 ? "success" : "error")}
                                                        additionalInfo={bulkUploadLoading ? `${bulkUploadProgress} of ${bulkUploadData.length} apps processed` : `${bulkUploadResult?.successCount || 0} succeeded, ${bulkUploadResult?.failCount || 0} failed`}
                                                        resultText={!bulkUploadLoading ? (bulkUploadResult?.failCount === 0 ? "All apps published successfully!" : `${bulkUploadResult?.successCount} published, ${bulkUploadResult?.failCount} failed`) : undefined}
                                                        label={bulkUploadLoading ? "Publishing apps to marketplace..." : "Upload complete"}
                                                    />
                                                    {bulkUploadLoading && <Box color="text-body-secondary" fontSize="body-s">Please do not close this page while publishing is in progress.</Box>}
                                                    {!bulkUploadLoading && bulkUploadResult?.successCount > 0 && (
                                                        <Alert type="info">It may take up to 60 minutes for the new apps to appear on the marketplace.</Alert>
                                                    )}
                                                    {!bulkUploadLoading && bulkUploadResult && (
                                                        <Alert type={bulkUploadResult.failCount === 0 ? "success" : "warning"}>
                                                            <SpaceBetween size="s">
                                                                <Box><strong>{bulkUploadResult.successCount}</strong> apps published successfully{bulkUploadResult.failCount > 0 ? <>, <strong>{bulkUploadResult.failCount}</strong> failed</> : ""}.</Box>
                                                                {bulkUploadResult.errors.length > 0 && (
                                                                    <ExpandableSection headerText={`View ${bulkUploadResult.errors.length} error(s)`} variant="footer">
                                                                        <Table
                                                                            columnDefinitions={[
                                                                                { id: "row", header: "Row", cell: item => item.row, width: 60 },
                                                                                { id: "app", header: "App Name", cell: item => item.app, width: 200 },
                                                                                { id: "error", header: "Error", cell: item => item.error }
                                                                            ]}
                                                                            items={bulkUploadResult.errors.map((err, i) => {
                                                                                const match = err.match(/^Row (\d+) \((.+?)\): (.+)$/);
                                                                                return match ? { row: match[1], app: match[2], error: match[3] } : { row: i + 1, app: "—", error: err };
                                                                            })}
                                                                            sortingDisabled
                                                                        />
                                                                    </ExpandableSection>
                                                                )}
                                                            </SpaceBetween>
                                                        </Alert>
                                                    )}
                                                </SpaceBetween>
                                            </Modal>
                                        )}
                                    </SpaceBetween>
                                )}

                                {bulkUploadResult && (
                                    <Alert type={bulkUploadResult.failCount === 0 ? "success" : "warning"}>
                                        <SpaceBetween size="s">
                                            <Box><strong>{bulkUploadResult.successCount}</strong> apps published successfully{bulkUploadResult.failCount > 0 ? <>, <strong>{bulkUploadResult.failCount}</strong> failed</> : ""}.</Box>
                                            {bulkUploadResult.errors.length > 0 && (
                                                <ExpandableSection headerText={`View ${bulkUploadResult.errors.length} error(s)`} variant="footer">
                                                    <div style={{ maxHeight: "200px", overflow: "auto" }}>
                                                        <Table
                                                            columnDefinitions={[
                                                                { id: "row", header: "Row", cell: item => item.row, width: 60 },
                                                                { id: "app", header: "App Name", cell: item => item.app, width: 200 },
                                                                { id: "error", header: "Error", cell: item => item.error }
                                                            ]}
                                                            items={bulkUploadResult.errors.map((err, i) => {
                                                                const match = err.match(/^Row (\d+) \((.+?)\): (.+)$/);
                                                                return match ? { row: match[1], app: match[2], error: match[3] } : { row: i + 1, app: "—", error: err };
                                                            })}
                                                            sortingDisabled
                                                        />
                                                    </div>
                                                </ExpandableSection>
                                            )}
                                        </SpaceBetween>
                                    </Alert>
                                )}
                            </SpaceBetween>
                        </Container>

                        {/* Discarded Applications */}
                        <Container>
                            <SpaceBetween size="l">
                                <Header
                                    variant="h3"
                                    actions={
                                        <Button iconName="refresh" onClick={() => loadArchivedApps()}>Refresh</Button>
                                    }
                                >
                                    Discarded Applications
                                </Header>
                                {archivedAppsLoading ? (
                                    <Box textAlign="center" padding="l"><Spinner /> Loading discarded apps...</Box>
                                ) : (
                                    <div className="ag-theme-alpine" style={{ width: "100%" }}>
                                        <AgGridReact
                                            rowData={archivedApps}
                                            domLayout="autoHeight"
                                            columnDefs={[
                                                { field: "app_name", headerName: "App Name", filter: true, sortable: true, resizable: true, minWidth: 200 },
                                                { field: "app_owner", headerName: "App Owner", filter: true, sortable: true, resizable: true, minWidth: 120 },
                                                { field: "app_description", headerName: "Description", filter: true, sortable: true, resizable: true, minWidth: 250 },
                                                { field: "archival_reason", headerName: "Discard Reason", filter: true, sortable: true, resizable: true, minWidth: 200 },
                                                { field: "created_at", headerName: "Created At", filter: true, sortable: true, resizable: true, minWidth: 120 },
                                                { field: "last_updated_at", headerName: "Discarded On", filter: true, sortable: true, resizable: true, minWidth: 120 },
                                                { field: "created_by", headerName: "Created By", filter: true, sortable: true, resizable: true, minWidth: 120 },
                                            ]}
                                            defaultColDef={{
                                                resizable: true,
                                                sortable: true,
                                                filter: true,
                                                floatingFilter: true,
                                                filterParams: {
                                                    applyMiniFilterWhileTyping: true
                                                },
                                                suppressMenuHide: true,
                                            }}
                                            animateRows={true}
                                            pagination={true}
                                            paginationPageSize={20}
                                            suppressScrollOnNewData={true}
                                            ensureDomOrder={true}
                                        />
                                    </div>
                                )}
                            </SpaceBetween>
                        </Container>
                        </SpaceBetween>
                    </ContentLayout>
                </div>
                ) : (
                    <ErrorComponent header="Access Denied" message="You do not have access to the AI Repo Control Panel. Please contact an AI Repository admin." />
                )
            ) : (
                <>
                <Modal visible={showSuccesModal}
                onDismiss={()=>{setShowSuccesModal(false)}}>
                    <Box>
                        <Icon name="status-positive" variant="success" /> Job run complete to push controls to GRC, please check back in 10 minutes on GRC for corresponding controls.! (Do not re-trigger within this timeframe)
                    </Box>
                </Modal>
                
                <Modal visible={showTriggerInfoMsg}
                onDismiss={()=>{setShowTriggerInfoMsg(false)}}>
                    <Box>
                        <Icon name="status-info" variant="info" /> Job initiated and running to push apps to GRC, you may close this and check back on GRC after 10 minutes for corresponding controls. (Do not re-trigger within this timeframe)
                    </Box>
                </Modal>
                <div className="mainPage">
                    <ContentLayout
                        headerVariant="high-contrast"
                        header={
                            <SpaceBetween size="m">
                                <Header
                                    variant="h1"
                                    description="Admin panel for editing the app metadata."

                                >
                                    Admin panel
                                </Header>
                            </SpaceBetween>
                        }
                    >


                        <Container>

                            <SpaceBetween size="l">
                                <ColumnLayout columns={3}>
                                    <>

                                        {fieldTypes ? (Array.from(fieldTypes).map((value, index) => {
                                            return getView(value.label, value.key);
                                        })) : ''}
                                    </>

                                </ColumnLayout>

                            </SpaceBetween>
                        </Container>
                        <br></br>
                        <Container>
                            <Tabs
                                activeTabId={activeTabId}
                                onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
                                tabs={[
                                    {
                                        label: "All Apps",
                                        id: "all-apps",
                                        content: (
                                            <SpaceBetween size="l">
                                                <SpaceBetween size="l" direction="horizontal">
                                                    <Box float="right" padding="m">
                                                        <SpaceBetween direction="horizontal" size="xl">
                                                            {/* <Button variant="icon" iconName="undo" onClick={(()=>undo())}></Button>
      <Button variant="icon" iconName="redo" onClick={(()=>redo())}></Button> */}
                                                            <Button variant="primary" onClick={() => downloadAllapps()}>Export all apps to a sheet</Button>
                                                            <Button onClick={(() => setShowSaveAllAppsModal(true))} disabled={undoEditCount <= 0 || rowGroupColumns?.length > 0}>Save</Button>
                                                            <ButtonDropdown
                                                                items={[
                                                                    {
                                                                        text: "Export to excel",
                                                                        items: [
                                                                            { text: "Current view", id: "current_view", disabled: false },
                                                                            // { text: "Selected rows", id: "selected_rows", disabled: false },
                                                                            { text: "Original", id: "original", disabled: false }
                                                                        ]
                                                                    }
                                                                ]}
                                                                onItemClick={(event) => {
                                                                    if (event.detail.id == 'current_view') {
                                                                        exportAllApps({ 'filtered': true })
                                                                    } else if (event.detail.id == 'selected_rows') {
                                                                        exportAllApps({ 'selectedOnly': true })
                                                                    }
                                                                    else if (event.detail.id == 'original') {
                                                                        exportAllApps()
                                                                    }
                                                                }}
                                                            >
                                                                Actions
                                                            </ButtonDropdown>
                                                            <Button onClick={(() => addNewApp({'template_id': '01H8YZ31RPXS11HFABMHA6J4F0','app_description':'A new app', 'process_owner': userId, 'grc_control_owner': userId}))} iconName="insert-row">Add</Button>
                                                            {/* <Button variant="icon" iconName="unlocked" onClick={(()=>handleViewChanges())}></Button> */}
                                                            <Button variant="icon" iconName="refresh" onClick={(() => loadAllAppsView())}></Button>
                                                            <Box><span className="last_updated">Info : Add/Update functionality not available for QSC apps</span></Box>
                                                        </SpaceBetween>
                                                    </Box>
                                                </SpaceBetween>
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    {allAppsEditLoader ? <Box> <Spinner></Spinner>{allAppsEditLoader}</Box> : <></>}
                                                    {allAppsEditError ? <Box> <span className="error_message">{allAppsEditError}</span> </Box> : <></>}
                                                    {
                                                        (!(undoEditCount <= 0 || rowGroupColumns?.length > 0)) ? <Box><StatusIndicator type="warning">Attention: You have unsaved work</StatusIndicator></Box> : ''
                                                    }
                                                    {
                                                        annotationSaveSuccessMessage ? <StatusIndicator type="success">{annotationSaveSuccessMessage}</StatusIndicator> : ''
                                                    }
                                                </SpaceBetween>

                                                <div style={{
                                                    width: '100%',
                                                    height: 'calc(100vh - 300px)',
                                                }}>
                                                    <div
                                                        className="ag-theme-alpine"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            minHeight: '500px'
                                                        }}
                                                    >
                                                        <AgGridReact
                                                            ref={gridRef}
                                                            rowData={allApps}
                                                            defaultColDef={defaultProjectColDef}
                                                            columnDefs={columnsList}
                                                            enableRangeSelection={true}
                                                            enableRangeHandle={true}
                                                            rowSelection="multiple"
                                                            onSelectionChanged={onSelectionChanged}
                                                            suppressRowClickSelection={true}
                                                            rowMultiSelectWithClick={true}
                                                            rowNumbers={true}
                                                            // editType={"fullRow"}
                                                            animateRows={true}
                                                            rowHeight={30}
                                                            enableCellTextSelection={false}
                                                            stopEditingWhenCellsLoseFocus={true}
                                                            undoRedoCellEditing={true}
                                                            undoRedoCellEditingLimit={10}
                                                            onCellValueChanged={onCellValueChanged}
                                                            onCellFocused={onCellFocused}
                                                            // onGridReady={onGridReady}
                                                            onColumnRowGroupChanged={onColumnRowGroupChanged}
                                                            rowGroupPanelShow="always"
                                                            // sideBar={sideBar}
                                                            // groupTotalRow="bottom"
                                                            groupAggFiltering={false}
                                                            pivotMode={false}
                                                            suppressAggFuncInHeader={false}
                                                            enableCellSelection={true}
                                                            // onRangeSelectionChanged={onRangeSelectionChanged}
                                                            // getContextMenuItems={getContextMenuItems}
                                                            enableContextMenu={true}
                                                            // onModelUpdated={onModelUpdated}
                                                            // onFilterChanged={onFilterChanged}
                                                            // onViewportChanged={onViewportChanged}
                                                            suppressMenuHide={true}
                                                            suppressScrollOnNewData={true}
                                                            ensureDomOrder={true}
                                                        />
                                                    </div>
                                                </div>
                                            </SpaceBetween>
                                        )
                                    },
                                    {
                                        label: "Inactive Users",
                                        id: "inactive-users",
                                        content: (
                                            <SpaceBetween size="l">
                                                <SpaceBetween size="l" direction="horizontal">
                                                    <Box float="right" padding="m">
                                                        <SpaceBetween direction="horizontal" size="xl">
                                                            <Button variant="primary" onClick={() => exportInactiveUsers()}>Export inactive users report</Button>
                                                            <Button variant="icon" iconName="refresh" onClick={() => loadInactiveUsersReport()}>Refresh</Button>
                                                            <Box><span className="last_updated">Apps with inactive users in GRC Control Owner, Process Owner, or VP fields</span></Box>
                                                        </SpaceBetween>
                                                    </Box>
                                                </SpaceBetween>
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    {inactiveUsersLoader ? <Box> <Spinner></Spinner>Loading inactive users report...</Box> : <></>}
                                                    {inactiveUsersError ? <Box> <span className="error_message">{inactiveUsersError}</span> </Box> : <></>}
                                                    {inactiveUsersData.length > 0 ? <Box><StatusIndicator type="info">Found {new Set(inactiveUsersData.map(user => user.alias)).size} unique inactive users for {new Set(inactiveUsersData.map(user => user.app_name)).size} apps.</StatusIndicator></Box> : ''}
                                                </SpaceBetween>

                                                <div style={{
                                                    width: '100%',
                                                    height: 'calc(100vh - 300px)',
                                                }}>
                                                    <div
                                                        className="ag-theme-alpine"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            minHeight: '500px'
                                                        }}
                                                    >
                                                        <AgGridReact
                                                            rowData={inactiveUsersData}
                                                            defaultColDef={{
                                                                resizable: true,
                                                                sortable: true,
                                                                filter: true,
                                                                editable: false,
                                                                filterParams: {
                                                                    closeOnApply: false,
                                                                    buttons: ['apply', 'clear'],
                                                                    defaultOption: 'contains'
                                                                }
                                                            }}
                                                            columnDefs={inactiveUsersColumnsList}
                                                            enableRangeSelection={true}
                                                            rowSelection="multiple"
                                                            suppressRowClickSelection={true}
                                                            rowMultiSelectWithClick={true}
                                                            rowNumbers={true}
                                                            animateRows={true}
                                                            rowHeight={30}
                                                            enableCellTextSelection={false}
                                                            suppressMenuHide={true}
                                                            suppressScrollOnNewData={true}
                                                            ensureDomOrder={true}
                                                        />
                                                    </div>
                                                </div>
                                            </SpaceBetween>
                                        )
                                    },
                                    {
                                        label: "Cost Centres outside of FGBS",
                                        id: "outside-cost-centers",
                                        content: (
                                            <SpaceBetween size="l">
                                                <SpaceBetween size="l" direction="horizontal">
                                                    <Box float="right" padding="m">
                                                        <SpaceBetween direction="horizontal" size="xl">
                                                            <Button variant="primary" onClick={() => exportOutsideCostCenterUsers()}>Export outside cost centers report</Button>
                                                            <Button variant="icon" iconName="refresh" onClick={() => loadOutsideCostCenterReport()}>Refresh</Button>
                                                            <Box><span className="last_updated">Active users outside allowed cost centers ({allowedCostCenters.join(', ')})</span></Box>
                                                        </SpaceBetween>
                                                    </Box>
                                                </SpaceBetween>
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    {outsideCostCenterLoader ? <Box> <Spinner></Spinner>Loading outside cost centers report...</Box> : <></>}
                                                    {outsideCostCenterError ? <Box> <span className="error_message">{outsideCostCenterError}</span> </Box> : <></>}
                                                    {outsideCostCenterData.length > 0 ? <Box><StatusIndicator type="info">Found {new Set(outsideCostCenterData.map(user => user.alias)).size} unique users outside cost center for {new Set(outsideCostCenterData.map(user => user.app_name)).size} apps.</StatusIndicator></Box> : ''}
                                                </SpaceBetween>

                                                <div style={{
                                                    width: '100%',
                                                    height: 'calc(100vh - 300px)',
                                                }}>
                                                    <div
                                                        className="ag-theme-alpine"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            minHeight: '500px'
                                                        }}
                                                    >
                                                        <AgGridReact
                                                            rowData={outsideCostCenterData}
                                                            defaultColDef={{
                                                                resizable: true,
                                                                sortable: true,
                                                                filter: true,
                                                                editable: false,
                                                                filterParams: {
                                                                    closeOnApply: false,
                                                                    buttons: ['apply', 'clear'],
                                                                    defaultOption: 'contains'
                                                                }
                                                            }}
                                                            columnDefs={outsideCostCenterColumnsList}
                                                            enableRangeSelection={true}
                                                            rowSelection="multiple"
                                                            suppressRowClickSelection={true}
                                                            rowMultiSelectWithClick={true}
                                                            rowNumbers={true}
                                                            animateRows={true}
                                                            rowHeight={30}
                                                            enableCellTextSelection={false}
                                                            suppressMenuHide={true}
                                                            suppressScrollOnNewData={true}
                                                            ensureDomOrder={true}
                                                        />
                                                    </div>
                                                </div>
                                            </SpaceBetween>
                                        )
                                    }
                                ]}
                            />
                        </Container>
                        <br></br>
                        <Container>

                            <h3>Select Quarter and Year</h3>
                            <SpaceBetween size="l" direction="horizontal">
                                <Select
                                    selectedOption={selectedQuarter}
                                    onChange={({ detail }) =>
                                        setSelectedQuarter(detail.selectedOption)
                                    }
                                    options={quarters}
                                />
                                <Select
                                    selectedOption={selectedYear}
                                    onChange={({ detail }) =>
                                        setSelectedYear(detail.selectedOption)
                                    }
                                    options={years}
                                />
                                <Button variant="primary" disabled={!(selectedQuarter && selectedYear)} onClick={() => downloadEligibleGRCAppsToBePushed()}>Export Eligible apps to be pushed to GRC by Selected Quarter and Year</Button>
                                <Button variant="primary" disabled={!(selectedQuarter && selectedYear)} onClick={() => pushAppsToGRC()}>Push Eligible apps to GRC</Button>
                            </SpaceBetween>
                        </Container>
                        <br></br>
                        <Container>

                            <h3>Download Audit logs</h3>
                            <SpaceBetween size="l" direction="horizontal">
                                <Select
                                    selectedOption={selectedAuditLogQuarter}
                                    onChange={({ detail }) =>
                                        setSelectedAuditLogQuarter(detail.selectedOption)
                                    }
                                    options={quarters}
                                />
                                <Select
                                    selectedOption={selectedAuditLogYear}
                                    onChange={({ detail }) =>
                                        setSelectedAuditLogYear(detail.selectedOption)
                                    }
                                    options={years}
                                />
                                <Button variant="primary" disabled={!(selectedAuditLogQuarter && selectedAuditLogYear && showAuditLoader==null) } onClick={() => downloadFRISCOLogs()}>FRISCO</Button>
                                <Button variant="primary" disabled={!(selectedAuditLogQuarter && selectedAuditLogYear && showAuditLoader==null)} onClick={() => downloadFRISCOMetadataLogs()}>FRISCO Metadata</Button>

                                        {
                                            showAuditLoader && showAuditLoader.length > 0 && <SpaceBetween direction="vertical" size="m">
                                                {showAuditLoader?.map((item, index) => (
                                                    <StatusIndicator key={index} type={item.type}>
                                                        {item.message}
                                                    </StatusIndicator>
                                                ))}
                                            </SpaceBetween>
                                        }
                            </SpaceBetween>
                        </Container>
                        <br></br>
                        <BannerManager allApps={allApps} userId={userId}/>
                        <br></br>
                        <PulseSurveyNotificationManager allApps={allApps} userId={userId}/>                        

                            <Modal
                                onDismiss={() => closeSaveAllAppsModal()}
                                visible={showSaveAllAppsModal}
                                footer={
                                    <Box float="right">
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <Button variant="link" onClick={() => { closeSaveAllAppsModal() }}>Cancel</Button>
                                            <Button variant="primary" onClick={() => {
                                                saveChangedApps(); setShowSaveAllAppsModal(false); setTimeout(() => {
                                                    // resetting comments after a delay so that the comment is not null when used in saveChangedApps
                                                    closeSaveAllAppsModal()
                                                }, 1000);
                                            }}>Ok</Button>
                                        </SpaceBetween>
                                    </Box>
                                }
                                header="Update comments"
                            >
                                <Textarea
                                    onChange={({ detail }) => setShowSaveAllAppsComments(detail.value)}
                                    value={showSaveAllAppsComments}
                                    placeholder="comments"
                                />
                            </Modal>
                            {searchParams.get("upload") === "true" && <UploadAppModal onCloseModal={() => searchParams.delete("upload")}/>}
                    </ContentLayout>
                </div>
                </>
            )
            }

        </>
    )


    return (
        <AppLayout
            disableContentPaddings={true}
            content={Content}
            navigation={<SideNav activeHref={`/Admin`} />}
            contentType="default"
            navigationOpen={NavOpen}
            onNavigationChange={() => {
                setNavOpen(!NavOpen);
            }}
            toolsHide={true}
            toolsOpen={toolsOpen}
            onToolsChange={() => { setToolsOpen(!toolsOpen) }}
            headerVariant="high-contrast"
        />
    );
};
